module.exports = __webpack_public_path__ + "89ba5530f3b2c751f2a49e25f31e3f15.woff2";